'use client';

import BlogCard from '@/components/BlogCard';
import HorizontalSlider from '@/components/HorizontalSlider';
import SliderSection from '@/components/SliderSection';
import { BlogPost } from '@/types/blog.type';

import styles from './FeaturedBlogsSection.module.scss';

interface FeaturedBlogsSectionProps {
  title?: string;
  posts: BlogPost[];
  featuredLabel?: string;
}

const FeaturedBlogsSection = ({ title, posts, featuredLabel }: FeaturedBlogsSectionProps) => (
  <SliderSection title={title}>
    {handleSwiper => (
      <HorizontalSlider
        data={posts}
        handleSwiper={handleSwiper}
        customStyles={{ slide: styles.slide }}
        renderItem={(post: BlogPost) => (
          <BlogCard
            slug={post.slug}
            image={post.cardImage}
            bannerImage={post.bannerImage}
            imageAlt={post.title}
            date={post.date}
            readTime={post.readTime}
            title={post.title}
            author={post.author}
            featured={post.featured}
            featuredLabel={featuredLabel}
          />
        )}
      />
    )}
  </SliderSection>
);

export default FeaturedBlogsSection;
